<script setup>
import { reactive, onMounted, h } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const list = reactive([])

onMounted(() => {})

const handleQi = () => {
  location.href =
    'https://www.quectel.com.cn/product-category/arm-platform-dev-board?tid='
}

const aLphaImage = new URL('/public/image/alpha.png', import.meta.url)
</script>

<template>
  <div class="quec-qi">
    <h2 class="title">{{ t('common.board') }}</h2>
    <div class="qi-content">
      <div class="img-wrapper" @click="handleQi">
        <img v-lazy="aLphaImage" />
      </div>
      <div class="text-wrapper">
        <p class="title">Quectel Pi H1</p>
        <p class="dec">{{ t('common.ecological') }}</p>
        <ul>
          <li>PCBA 封装</li>
          <li>(108.94 ±0.2) mm × (68.70 ±0.2) mm × (23.00 ±0.2) mm</li>
          <li>71.6 ± 0.5 g</li>
        </ul>
        <p class="more" @click="handleQi">了解更多</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
li {
  color: #666;
}

.quec-qi {
  padding: 20px;
  background: #f3f5f5;

  .title {
    height: 42px;
    text-align: center;
    font-size: 30px;
    font-weight: 500;
    color: #000;
    padding-top: 96px;
  }

  .qi-content {
    width: 1170px;
    margin: auto;
    display: flex;
    justify-content: center;
    margin: 70px auto 96px;

    .img-wrapper {
      height: 400px;
      width: 570px;
      display: flex;
      background: #fff;
      cursor: pointer;
      justify-content: center;
      align-items: center;

      img {
        box-sizing: border-box;
        width: 317px;
        height: 317px;
      }
    }

    .text-wrapper {
      flex: 1;
      padding-left: 100px;
      text-align: left;
      color: #666;

      .title {
        font-size: 30px;
        height: 38px;
        text-align: left;
        color: #14111f;
      }

      .dec {
        margin-top: 10px;
        height: 22px;
        text-align: left;
        color: #666666;
      }

      ul {
        transform: translateX(20px);
        padding: 34px 0;

        li {
          line-height: 24px;
          font-size: 14px;
        }
      }

      .more {
        height: 20px;
        color: #a5a9a9;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          color: #999;
        }
      }
    }
  }

  .introduce {
    color: #666;
    padding: 0 200px;
    font-size: 14px;
    padding-bottom: 80px;
  }
}
</style>
